module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_05.ce193caa.svg";